export default __webpack_public_path__ + "static/media/Number_check_hsb.501650e8.svg";